(function($){
    $.fn.extend({
        Toast: function(options) {
            // jQuery.fn.Toast();
            // Settings list and the default values
            const defaults = {
                title: 'La Parfumerie',
                content: '...',
                timeoutSeconds: 30
            };

            options = $.extend(defaults, options);

            const random_id = `toast_${$.fn.generateId()}`;

            let toast = `<div role="alert" aria-live="assertive" aria-atomic="true" class="toast" data-animation="false" data-delay="${options.timeoutSeconds * 1000}"  id="${random_id}">
              <div class="d-flex px-3 py-2 toast-header">
                <strong class="mr-auto">${options.title}</strong>
                <small id="toast_timer" class="mr-2"></small>
                <button type="button" class="close" data-dismiss="toast" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="toast-body px-3 py-2">${options.content}</div>
            </div>`;

            $('.toast-wrapper').prepend(toast);

            const toastElement = $('#'+random_id);

            toastElement.toast('show');

            $('#'+random_id + ' #toast_timer').countdown({
                until: + options.timeoutSeconds,
                format: 'MS',
                timeSeparator: ':',
                compact: true,
            });

            toastElement.on('hidden.bs.toast', function () {
                $('#'+random_id + ' #toast_timer').countdown('destroy');
                $(this).remove();
            })
        },
        generateId: function (options) {

            let prefix             = '';
            const characters       = 'abcdefghijklmnopqrstuvwxyz';
            const charactersLength = characters.length;
            for ( let i = 0; i < 3; i++ ) {
                prefix += characters.charAt(Math.floor(Math.random() * charactersLength));
            }

            const defaults = {
                prefix: prefix,
            };

            options = $.extend(defaults, options);

            return options.prefix + '_' + Math.floor((Math.random() * 234234234) + 1);
        },
    });
})(jQuery);